import React from 'react';

/** `.eyebrow` — pastille de surtitre. Variantes : yellow (défaut) | pink | teal | white. */
const Eyebrow = ({ variant, className = '', style, children }) => (
  <span className={['eyebrow', variant, className].filter(Boolean).join(' ')} style={style}>
    {children}
  </span>
);

export default Eyebrow;
